import fetchData from './fetchData';
import config from './apiConfig';

export default () =>
    new Promise((resolve, reject) => {
  const options = {
            ...config.getSupplierContractTiles,
            url: `${config.getSupplierContractTiles.url}`,
        };
        return fetchData(options)
    .then((data) => {
      if (data && !data.ErrorCode) {
                    resolve(data);
      } else {
                    reject({ fetchError: true, details: data });
                }
            })
    .catch((error) => {
      reject(error);
            });
});
